module.exports = __webpack_public_path__ + "img/bookshelf08.073d070a.jpg";